import { useEffect, useState } from 'react';

import type { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';

export default function useGetDefaultVenueIds(venues: Venue[] | null) {
  const [selectedVenueIds, setSelectedVenueIds] = useState<string[]>([]);

  useEffect(() => {
    if (venues) {
      const defaultSelectedVenueIds: string[] = venues.map(venue => venue.id);
      setSelectedVenueIds(defaultSelectedVenueIds);
    }
  }, [venues]);

  return { selectedVenueIds, setSelectedVenueIds };
}
